//Componentes generales
import React, { useReducer } from "react";
import agregarSoliAjusReducer from "./agregarSoliAjusReducer";
import agregarSoliAjusContext from "./agregarSoliAjusContext";

//Axios
import clienteAxios from "../../config/axios";

//Rutas de api
import {
  addFiles,
  addSolicitudAjuste,
  deleteFile,
  updateSolicitudAjuste,
} from "../../api/solicitudAjuste";

//Acciones
import {
  CARGAR_SOLI,
  MODIFICAR_SOLI,
  GUARDAR_SOLICITUD,
  CARGANDO_ADD,
  ERROR_ADD,
  SELECCIONAR_FILE,
  ELIMINAR_FILE,
  ERROR,
  LIMPIAR_ERROR,
} from "./agregarSoliAjusActions";

/* 
    State encargado de la llamada al backend para agregar una nueva solicitud de ajuste.
*/
const AgregarSoliAjusState = (props) => {
  //Valores inciales
  const initialState = {
    soliAjus: {
      soliAjusCodFor: "",
      nroCta: "",
      notePubl: "",
      notePriv: "",
    },
    files: [],
    modSoliAjus: false,
    cargando: false,
    error: "",
  };

  const [state, dispatch] = useReducer(agregarSoliAjusReducer, initialState);

  const guardarSolicitudAjuste = async (solicitud, user, files) => {
    let createdsolicitudAjuste = null;

    try {
      const soliAjus = {
        ...solicitud,
        soliAjusCodFor: "SOLI",
        soliAjusUserID: user._id,
        userName: user.userName,
        nroCta: user.nroCta,
      };

      const formData = new FormData();

      if (files?.length > 0) {
        files.map((f, i) => {
          formData.append(`${i}`, f);
        });
      }

      formData.append("solicitudAjuste", JSON.stringify(soliAjus));

      const resp = await addSolicitudAjuste(formData);
      createdsolicitudAjuste = resp.data.data;

      dispatch({
        type: GUARDAR_SOLICITUD,
      });
      console.log("Guardar solicitud de ajuste.");
      console.log(resp.data.data);
      return createdsolicitudAjuste;
    } catch (error) {
      /* dispatch({
                type: ERROR,
                payload: error.message
            })
            throw new Error(error.message); */
      throw error;
    }
  };

  const cargarSolicitudAjuste = (soliAjus) => {
    dispatch({
      type: CARGAR_SOLI,
      payload: soliAjus,
    });
  };

  const modificarSolicitudAjuste = (modificar) => {
    dispatch({
      type: MODIFICAR_SOLI,
      payload: modificar,
    });
  };

  const editarSolicitudAjusteBE = async (
    solicitud,
    files,
    usuario
  ) => {
    try {
      const formData = new FormData();

      formData.append("soliAjusId", JSON.stringify(solicitud._id));
      formData.append("updates", JSON.stringify(solicitud));
      formData.append("fecMod", JSON.stringify(solicitud.fecMod));
      formData.append("user", JSON.stringify(usuario));

      // Archivos nuevos
      if (files?.length > 0) {
        files.forEach((file) => {
          formData.append("files", file);
        });
      }

      const resp = await updateSolicitudAjuste(formData);

      const solicitudAjusteUpdated = resp.data.data;

      dispatch({
        type: GUARDAR_SOLICITUD,
      });

      return solicitudAjusteUpdated;
    } catch (error) {
      /* dispatch({
        type: ERROR_ADD,
        payload: error.message,
      });
      throw new Error(error.message); */
      throw error;
    }
  };

  /* 
        Función para carga.
        No esta en uso.
    */
  const cargando = async () => {
    dispatch({
      type: CARGANDO_ADD,
    });
  };

  /* 
        Función que selecciona un archivo.
    */
  const seleccionarFile = async () => {
    try {
      const fileUpload = null;

      if (fileUpload.name !== undefined) {
        dispatch({
          type: SELECCIONAR_FILE,
          payload: fileUpload,
        });
      }
    } catch (error) {}
  };

  const eliminarFile = (file) => {
    console.log(file);
    dispatch({
      type: ELIMINAR_FILE,
      payload: file,
    });
  };

  /* 
        Función que limpia el valor de error.
    */
  const limpiarError = async () => {
    dispatch({
      type: LIMPIAR_ERROR,
    });
  };

  return (
    <agregarSoliAjusContext.Provider
      value={{
        soliAjus: state.soliAjus,
        modSoliAjus: state.modSoliAjus,
        isCargando: state.cargando,
        error: state.error,
        cargarSolicitudAjuste,
        modificarSolicitudAjuste,
        guardarSolicitudAjuste,
        cargando,
        seleccionarFile,
        eliminarFile,
        limpiarError,
        editarSolicitudAjusteBE,
      }}
    >
      {props.children}
    </agregarSoliAjusContext.Provider>
  );
};

export default AgregarSoliAjusState;

/* 
    Actualmente no esta en uso.
*/
const toFileUpload = (file) => {
  let { name, mimeType, size, uri } = file;

  let fileToUpload = {
    name: name,
    size: size,
    uri: uri,
    type: mimeType,
  };

  return fileToUpload;
};
